<template>
    <div>
        <!-- Toolbar amélioré avec ombre et hauteur ajustée -->
        <v-toolbar
            dense
            tabs
            color="primary darken-2"
            dark
            class="page_title elevation-2"
        >
            <v-toolbar-title class="pa-0 pr-0 mt-1">
                <v-layout row align-center>
                    <v-flex xs10 sm11 text-xs-left>
                        <a href="javascript: history.go(-1)" class="pa-0">
                            <v-btn flat fab small class="pa-0 mr-2">
                                <v-icon>arrow_back</v-icon>
                            </v-btn>
                        </a>
                        <span class="headline font-weight-medium">Our Team</span>
                    </v-flex>
                    <v-flex xs2 sm1 text-xs-right>
                        <router-link :to="{name: 'All'}" class="pa-0 text-xs-right">
                            <v-btn flat fab small class="pa-0">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </router-link>
                    </v-flex>
                </v-layout>
            </v-toolbar-title>
        </v-toolbar>

        <v-container class="pa-0 pa-sm-3 pt-sm-4">
            <v-layout row>
                <v-flex xs12 md10 offset-md1>
                    <v-slide-y-transition mode="out-in">
                        <div>
                            <!-- Section Hero Images avec overlay gradient -->
                            <div class="mb-4 px-3 px-sm-0">
                                <v-layout row wrap class="hidden-sm-and-down">
                                    <v-flex xs6 class="pa-1">
                                        <div class="hero-img-wrapper">
                                            <v-img
                                                :src="require('@/assets/images/team1.jpg')"
                                                alt="Team member 1"
                                                height="240px"
                                                class="hero-img"
                                            ></v-img>
                                            <div class="hero-overlay">
                                                <span class="white--text subheading font-weight-medium"></span>
                                            </div>
                                        </div>
                                    </v-flex>
                                    <v-flex xs6 class="pa-1">
                                        <div class="hero-img-wrapper">
                                            <v-img
                                                :src="require('@/assets/images/team2.jpg')"
                                                alt="Team member 2"
                                                height="240px"
                                                class="hero-img"
                                            ></v-img>
                                            <div class="hero-overlay">
                                                <span class="white--text subheading font-weight-medium"></span>
                                            </div>
                                        </div>
                                    </v-flex>
                                </v-layout>

                                <div class="hidden-md-and-up">
                                    <div class="hero-img-wrapper mb-3">
                                        <v-img
                                            :src="require('@/assets/images/team1.jpg')"
                                            alt="Team member 1"
                                            width="100%"
                                            height="180px"
                                            class="hero-img"
                                        ></v-img>
                                        <div class="hero-overlay">
                                            <span class="white--text subheading font-weight-medium"></span>
                                        </div>
                                    </div>
                                    <div class="hero-img-wrapper">
                                        <v-img
                                            :src="require('@/assets/images/team2.jpg')"
                                            alt="Team member 2"
                                            width="100%"
                                            height="180px"
                                            class="hero-img"
                                        ></v-img>
                                        <div class="hero-overlay">
                                            <span class="white--text subheading font-weight-medium"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Intro avec design card moderne -->
                            <v-card class="intro-section mb-4 mx-3 mx-sm-0" flat>
                                <v-card-text class="py-4">
                                    <v-layout row wrap align-center>
                                        <v-flex xs12 md1 class="text-xs-center text-md-left mb-2 mb-md-0">
                                            <v-avatar color="primary lighten-4" size="48">
                                                <v-icon color="primary">group</v-icon>
                                            </v-avatar>
                                        </v-flex>
                                        <v-flex xs12 md11>
                                            <p class="subheading grey--text text--darken-2 mb-0" style="line-height: 1.8;">
                                                With our team's diverse expertise in engineering, accounting, marketing, and law, we are equipped to tackle any challenge and deliver innovative solutions. Our fintech services and platform are designed with the highest level of security and reliability, ensuring that your financial transactions are safe and secure.
                                            </p>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>

                            <!-- Section titre équipe -->
                            <div class="px-3 px-sm-0 mb-3">
                                <v-layout row align-center>
                                    <div class="section-line primary mr-3"></div>
                                    <h2 class="title primary--text font-weight-bold text-uppercase tracking-wide">Meet the Team</h2>
                                </v-layout>
                            </div>

                            <!-- Team Grid avec design premium -->
                            <v-layout row wrap class="px-3 px-sm-0">
                                <v-flex 
                                    xs12 sm6 md6 lg3 
                                    v-for="(item, index) in team_members" 
                                    :key="item.id" 
                                    class="pa-2"
                                >
                                    <v-hover>
                                        <v-card 
                                            slot-scope="{ hover }" 
                                            :class="`elevation-${hover ? 12 : 2}`" 
                                            :to="item.link" 
                                            class="team-card"
                                        >
                                            <div class="img-wrapper">
                                                <v-img
                                                    :src="item.get_thumbnail"
                                                    aspect-ratio="1"
                                                    height="220px"
                                                    class="team-img"
                                                ></v-img>
                                                <v-fade-transition>
                                                    <div v-if="hover" class="img-overlay">
                                                        <v-btn 
                                                            fab 
                                                            small 
                                                            color="white" 
                                                            class="mx-2"
                                                        >
                                                            <v-icon color="primary">person</v-icon>
                                                        </v-btn>
                                                        <span class="white--text body-2 mt-2 d-block text-xs-center">View Profile</span>
                                                    </div>
                                                </v-fade-transition>
                                            </div>

                                            <v-card-title primary-title class="pb-3 pt-3">
                                                <div class="w-100">
                                                    <div class="caption grey--text text--darken-1 text-uppercase mb-1 font-weight-medium tracking-wide">
                                                        {{ item.position }}
                                                    </div>
                                                    <h3 class="title ma-0 primary--text font-weight-bold">
                                                        {{ item.name }}
                                                    </h3>
                                                    <v-divider class="my-2 primary" style="width: 40px;"></v-divider>
                                                </div>
                                            </v-card-title>

                                            <v-card-actions class="pt-0 px-3 pb-3">
                                                <v-spacer></v-spacer>
                                                <v-btn 
                                                    icon 
                                                    small 
                                                    class="social-btn"
                                                >
                                                    <v-icon small color="grey darken-1">linkedin</v-icon>
                                                </v-btn>
                                                <v-btn 
                                                    icon 
                                                    small 
                                                    class="social-btn"
                                                >
                                                    <v-icon small color="grey darken-1">email</v-icon>
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-hover>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-slide-y-transition>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        data() {
            return {
                team_members: []
            }
        },

        mounted(){
            this.getOurTeamInfo();
            this.$store.commit('setCloseURL', "/savings")
        },

        methods:{
            async getOurTeamInfo(){
                this.$store.commit('setIsLoading', true)

                await axios
                    .get('/api/v1/home/get/our_team/info/')
                    .then(response => {
                        this.team_members = response.data
                    })
                    .catch(error => {
                        if (error.response){
                            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }else{
                            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }
                    })
                this.$store.commit('setIsLoading', false)
            }
        }
    }
</script>

<style scoped>
    .hero-img-wrapper {
        position: relative;
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 8px 24px rgba(0,0,0,0.12);
        transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    }

    .hero-img-wrapper:hover {
        transform: translateY(-4px);
        box-shadow: 0 16px 40px rgba(0,0,0,0.18);
    }

    .hero-img {
        transition: transform 0.6s ease;
    }

    .hero-img-wrapper:hover .hero-img {
        transform: scale(1.05);
    }

    .hero-overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 24px 16px 16px;
        background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%);
        border-radius: 0 0 16px 16px;
    }

    .intro-section {
        border-radius: 12px;
        background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
        border-left: 4px solid var(--v-primary-base);
    }

    .section-line {
        width: 4px;
        height: 28px;
        border-radius: 2px;
    }

    .tracking-wide {
        letter-spacing: 0.08em;
    }

    .team-card {
        cursor: pointer;
        border-radius: 16px;
        transition: all 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);
        overflow: hidden;
    }

    .img-wrapper {
        position: relative;
        overflow: hidden;
    }

    .team-img {
        transition: transform 0.5s ease;
    }

    .team-card:hover .team-img {
        transform: scale(1.08);
    }

    .img-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        backdrop-filter: blur(2px);
    }

    .social-btn {
        transition: all 0.2s ease;
    }

    .social-btn:hover {
        background: var(--v-primary-lighten4) !important;
    }

    .w-100 {
        width: 100%;
    }

    @media (max-width: 600px) {
        .hero-img-wrapper {
            border-radius: 12px;
        }
        .hero-overlay {
            border-radius: 0 0 12px 12px;
        }
    }
</style>